import { render, staticRenderFns } from "./AffiliateDashboard2.vue?vue&type=template&id=34d9346f"
import script from "./AffiliateDashboard2.vue?vue&type=script&lang=js"
export * from "./AffiliateDashboard2.vue?vue&type=script&lang=js"
import style0 from "./AffiliateDashboard2.vue?vue&type=style&index=0&id=34d9346f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports